const SimulationCustomerGranteesExtraInfoMessage = () => null;

export default SimulationCustomerGranteesExtraInfoMessage;
